import Button from './Button';
import Col from './Grid/Col';
import Row from './Grid/Row';
import Noimg from '@/assets/img/add_img@2x.png';
import iconAttachmentX from '@/assets/img/icons/ico_preview_attach_delete@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { usePopupStore } from '@/stores/PopupStore';
import { observer } from 'mobx-react-lite';
import React, {
  ChangeEventHandler,
  FC,
  InputHTMLAttributes,
  useCallback,
  useMemo,
} from 'react';
import styled from 'styled-components';

const AttachmentContainer = styled(Row)`
  margin: 0 -6px;
  align-items: flex-start;

  .col-left {
    padding: 0 6px;
  }

  .col-left {
    width: 100px;
  }
  .col-right {
    width: calc(100% - 100px);
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  ${Button} {
      width: 96px;
      height: 96px;
      background: transparent;
      border: none;
      padding: 0;
      position: relative;
      z-index: -1;
      img {
        width: 100%;
      }
    }
  }
  /* 우선 후원완료 페이지 기준으로 퍼블리싱 */
  ${breakpoint(`mobile`)} {
    .col-left {
      width: 96px;
    }
    .col-right {
      width: calc(100% - 96px);
    }

    ${Button} {
      font-size: 14px;
      padding: 0 12px;
    }
  }
`;

const InputFile = styled.input`
  display: none;
`;
const Label = styled.label`
  display: block;
  position: relative;
  z-index: 1;
`;
const FileCol = styled(Col)`
  overflow: hidden;
`;
const FilePreview = styled.div`
  height: 96px;
  line-height: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 16px;
  color: #828385;
`;
const FilePreviewImage = styled.div`
  display: inline-block;
  position: relative;
  margin-left: 6px;
  button {
    position: absolute;
    right: -4px;
    top: -4px;
  }
  span {
    display: inline-block;
    width: 96px;
    height: 96px;
    overflow: hidden;
    img {
      min-width: auto;
      min-height: 100%;
    }
  }
`;

interface AttachmentProps extends InputHTMLAttributes<HTMLInputElement> {
  maxFileCount?: number;
  files: File[];
  onFilesChange: (files: File[]) => void;
}

const AttachmentPreview: FC<AttachmentProps> = observer(
  ({ maxFileCount = 5, files, onFilesChange, ...props }) => {
    const popupStore = usePopupStore();

    // 첨부파일 지정
    const handleAttachmentFile: ChangeEventHandler<HTMLInputElement> = useCallback(
      (event) => {
        // null 인 경우
        if (!event.target.files) {
          return;
        }
        const newFiles = [...files, ...Array.from(event.target.files)];

        // 최대 갯수를 초과하면
        if (newFiles.length > maxFileCount) {
          popupStore.show(`최대 ${maxFileCount}개 까지 업로드 가능합니다`);
        }

        const finalFiles = newFiles.slice(0, maxFileCount);

        onFilesChange(finalFiles);

        // 파일 input 초기화
        event.target.value = null;
      },
      [files, maxFileCount, onFilesChange, popupStore],
    );

    const removeFile = (file: File) =>
      onFilesChange(files.filter((f) => f !== file));

    const images = useMemo(
      () => files.map((file) => URL.createObjectURL(file)),
      [files],
    );

    return (
      <AttachmentContainer>
        <div className="col-left">
          <Label>
            <InputFile
              type="file"
              onChange={handleAttachmentFile}
              {...props}
              accept="image/*"
            />
            <Button type="button">
              <img src={Noimg} alt="사진추가" />
              사진추가
            </Button>
          </Label>
        </div>
        <div className="col-right">
          {files.length > 0 ? (
            files.map((file, i) => (
              <FilePreviewImage key={file.name}>
                <span>
                  <img src={images[i]} alt={file.name} />
                </span>
                <button type="button" onClick={() => removeFile(file)}>
                  <img
                    src={iconAttachmentX}
                    alt="X"
                    width="24"
                    height="24"
                    css={`
                      cursor: pointer;
                    `}
                  />
                </button>
              </FilePreviewImage>
            ))
          ) : (
            <Row>
              <FileCol>
                <FilePreview>선택된 파일없음</FilePreview>
              </FileCol>
            </Row>
          )}
        </div>
      </AttachmentContainer>
    );
  },
);

export default AttachmentPreview;
